import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Stack,
  Slide,
  TextareaAutosize,
  FormControl,
  Typography,
  Button,
} from "@mui/material";
import PageHeader from "./../../components/PageHeader";
import ProfileBanner from "./../../components/ProfileBanner";
import SikiInput from "../../components/SikiInput";
import SocialInput from "./../../components/SocialInput";
import { Upload, Calendar, Plus, Lock } from "react-iconly";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Images } from "../../assets/common";
import DiscardPopup from "../../components/DiscardPopup";
import SuccessPopup from "../../components/SuccessPopup";
import ApiService from "./../../services/api-service";
import {
  disableDates,
  getErrorString,
  getUserDetail,
  updateUserDetail,
} from "./../../constants/function";
import Loader from "../../components/Loader";
import { Formik } from "formik";
import * as yup from "yup";
import notifier from "./../../components/Notifier";

const YOUTUBE_ICON =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'><path d='M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z'/></svg>";
import { useTranslation } from "react-i18next";
export default function EditProfile() {
  const { t } = useTranslation("common");
  const formRef = React.useRef();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [saveChange, setSaveChanges] = useState(false);

  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  // const { userinfo } = useContext(UserContext);
  const [amount, setAmount] = React.useState("");

  const [check, setChecked] = React.useState(true);
  let userDetail = getUserDetail();
  const schema = yup.object().shape({
    firstName: yup.string(),
    lastName: yup.string(),
    birthYear: yup.string(),
    bio: yup.string(),
    instagramLink: yup.string(),
    tikTokLink: yup.string(),
    youtubeLink: yup.string(),
    twitterLink: yup.string(),
  });
  useEffect(() => {
    const getUserData = async () => {
      setLoading(true);
      try {
        const response = await ApiService.USER_PROFILE();
        setLoading(false);
        setUserData(response["result"]);
        setAmount(
          response["result"]?.birthYear ? response["result"]?.birthYear : ""
        );
      } catch (error) {
        setLoading(false);
      }
    };
    if (userDetail) getUserData();
  }, []);

  //update proile
  const updateProfile = async (values) => {
    // console.log(formRef.values);

    try {
      if (
        formRef.current.values["firstName"].includes(" ") ||
        formRef.current.values["lastName"].includes(" ")
      ) {
        notifier.error(t("profileNameError"));
        return;
      }
      setLoading(true);

      const formData = new FormData();
      for (const key in formRef.current.values) {
        formData.append(key, formRef.current.values[key]);
      }
      const response = await ApiService.UPDATE_USER(formData);

      userDetail = response["result"];
      updateUserDetail(userDetail);
      setLoading(false);
      setSaveChanges(true);
    } catch (error) {
      setLoading(false);

      notifier.error(getErrorString(error));
    }
  };
  React.useEffect(() => {
    disableDates("dateOfBirth", "max");
  });

  let year = new Date().getFullYear();

  const checkinput = () => {
    if (amount < 1800) {
      notifier.error(t("notifier.error.toast6"));
      return;
    } else {
      updateProfile();
    }
  };

  return (
    <Box sx={{ paddingBottom: "1rem" }}>
      {userData["email"] ? (
        <Box>
          <ProfileBanner
            onUpdate={(user) => {
              setUserData({ ...user });
            }}
            userData={userData}
            edit={true}
            loader={setLoading}
          />
          <Formik
            innerRef={formRef}
            validationSchema={schema}
            onSubmit={(values) => {
              updateProfile(values);
            }}
            initialValues={{
              firstName: userDetail["firstName"],
              lastName: userDetail["lastName"],
              birthYear: userDetail["birthYear"] ? userDetail["birthYear"] : "",
              bio: userDetail["bio"] ? userDetail["bio"] : "",
              instagramLink: userDetail["instagramLink"]
                ? userDetail["instagramLink"]
                : "",
              tikTokLink: userDetail["tikTokLink"]
                ? userDetail["tikTokLink"]
                : "",
              youtubeLink: userDetail["youtubeLink"]
                ? userDetail["youtubeLink"]
                : "",
              twitterLink: userDetail["twitterLink"]
                ? userDetail["twitterLink"]
                : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
              setFieldValue,
            }) => (
              <form
                noValidate
                onSubmit={handleSubmit}
                className="__update_prfofile_box"
              >
                <Box sx={{ padding: "0 18px 50px" }}>
                  <Stack spacing={1}>
                    <SikiInput
                      label={t("editProfile.input1.label")}
                      placeholder={t("editProfile.input1.placeholder")}
                      value={values.firstName}
                      onChange={(e) => setFieldValue("firstName", e)}
                      left="10px"
                    />
                    <SikiInput
                      label={t("editProfile.input2.label")}
                      placeholder={t("editProfile.input2.label")}
                      value={values.lastName}
                      onChange={(e) => setFieldValue("lastName", e)}
                      top="13px"
                      left="10px"
                    />
                    <FormControl
                      className="__form_control"
                      style={{ width: "100%" }}
                    >
                      <Box className="__upload_inputbox">
                        {!userDetail["birthYear"] ? (
                          <SikiInput
                            label={t("editProfile.input3.label")}
                            placeholder={t("editProfile.input3.placeholder")}
                            type="number"
                            value={values.birthYear}
                            onChange={(e) => {
                              if (e > year) {
                                notifier.error(t("editProfile.input3.error"));
                              } else {
                                setAmount(e);
                                setFieldValue("birthYear", e);
                              }
                            }}
                            left="10px"
                          />
                        ) : (
                          <SikiInput
                            label={t("editProfile.input3.label")}
                            placeholder={t("editProfile.input3.placeholder")}
                            type="number"
                            value={values.birthYear}
                            disabled={true}
                            left="10px"
                          />
                        )}
                      </Box>
                    </FormControl>
                    <SikiInput
                      label={t("editProfile.input4.label")}
                      type="gender"
                      placeholder={t("editProfile.input4.placeholder")}
                      value={userData["gender"]}
                      disabled={true}
                      top="13px"
                      left="10px"
                    />
                    <SikiInput
                      label={t("editProfile.input5.label")}
                      placeholder={t("editProfile.input5.placeholder")}
                      multi={true}
                      value={values.bio}
                      onChange={(e) => setFieldValue("bio", e)}
                      top="13px"
                      left="10px"
                    />
                    <SikiInput
                      label={t("editProfile.input6.label")}
                      type="email"
                      placeholder={t("editProfile.input6.placeholder")}
                      value={userData["email"]}
                      onChange={() => console.log("")}
                      disabled={true}
                      top="13px"
                      left="10px"
                    />
                    <SocialInput
                      preFilled="https://twitter.com/"
                      label={t("editProfile.input7.label")}
                      placeholder={t("editProfile.input7.placeholder")}
                      icon={
                        <TwitterIcon
                          className="__input_icon __br"
                          sx={{ color: "#00AAEC" }}
                        />
                      }
                      value={values.twitterLink}
                      onChange={(e) => setFieldValue("twitterLink", e)}
                      left="10px"
                    />
                    <SocialInput
                      preFilled="https://www.instagram.com/"
                      placeholder={t("editProfile.input7.placeholder")}
                      icon={
                        <img
                          style={{ width: "20px" }}
                          src={Images.instagram}
                          alt="Insta"
                          className="__input_icon __br"
                        />
                      }
                      value={values.instagramLink}
                      onChange={(e) => setFieldValue("instagramLink", e)}
                    />
                    <SocialInput
                      preFilled="https://www.tiktok.com/en/"
                      placeholder={t("editProfile.input7.placeholder")}
                      icon={
                        <img
                          style={{ width: "20px" }}
                          src={Images.tiktok}
                          className="__input_icon __br"
                        />
                      }
                      value={values.tikTokLink}
                      onChange={(e) => setFieldValue("tikTokLink", e)}
                    />
                    <SocialInput
                      preFilled="https://www.youtube.com/@"
                      placeholder="YouTube channel"
                      icon={
                        <img
                          style={{ width: "20px" }}
                          src={YOUTUBE_ICON}
                          alt="YouTube"
                          className="__input_icon __br"
                        />
                      }
                      value={values.youtubeLink}
                      onChange={(e) => setFieldValue("youtubeLink", e)}
                    />
                  </Stack>
                  <Button
                    sx={{ width: "100%", marginTop: "20px" }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      checkinput();
                    }}
                  >
                    {t("editProfile.button")}
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      ) : null}
      <DiscardPopup
        open={open}
        handleClose={
          (e) =>
            e
              ? (setOpen(false), setSaveChanges(true)) //if  save show successpopup and close discard popup
              : (setOpen(false), history.goBack()) //if discard then close discard popup and go back to edit profile page
        }
      />
      {saveChange ? (
        <SuccessPopup
          open={saveChange}
          handleClose={(e) => (setSaveChanges(false), history.goBack())}
          message={t("success.message10")}
        />
      ) : null}
      {loading ? <Loader /> : null}
    </Box>
  );
}
